import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { TripVehicle } from "./types"
import { fromApi } from "./utils"
import { isNewPipelinePolicy } from "../../../utils"

export type Input = Readonly<{ policyId: string; vrn: string }>
type Output = TripVehicle

const getVehicle = createRequest<Input, Output>(async (input: Input, getToken): Promise<Output> => {
  const useNewPipeline = isNewPipelinePolicy(input.policyId)
  const vehicle = await platform(getToken).trips.getInsightsVehicle({
    ...input,
    ...(useNewPipeline ? { dbName: `athena` } : {}),
  })

  return fromApi(vehicle)
})

export const useGetTripVehicle = createRequestHook<Input, TripVehicle>(getVehicle)
